import React from 'react';
import { Linkedin, Mail, Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "../components/ui/dialog";

const steps = [
    "Connect with me on LinkedIn",
    "Send me a message mentioning this project",
    "I'll share repository access with you",
];

const Unlock = ({ showModal, handleClose, projectName }) => {
    return (
        <Dialog open={showModal} onOpenChange={(open) => !open && handleClose()}>
            <DialogContent>
                <DialogHeader>
                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-accent text-accent-foreground">
                        <Lock className="h-5 w-5" aria-hidden="true" />
                    </div>
                    <DialogTitle className="text-center">Get access to {projectName}</DialogTitle>
                    <DialogDescription className="text-center">
                        This repository is private. To unlock it, reach out:
                    </DialogDescription>
                </DialogHeader>

                <ol className="space-y-3">
                    {steps.map((step, index) => (
                        <li key={step} className="flex items-center gap-3 text-sm">
                            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary font-mono text-xs text-primary-foreground">
                                {index + 1}
                            </span>
                            {step}
                        </li>
                    ))}
                </ol>

                <div className="flex flex-col gap-2 sm:flex-row">
                    <Button className="flex-1" asChild>
                        <a
                            href="https://www.linkedin.com/in/mauric10"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Linkedin /> Connect on LinkedIn
                        </a>
                    </Button>
                    <Button variant="outline" className="flex-1" asChild>
                        <a href="mailto:mauricio@gonzalez-medina.com">
                            <Mail /> Email me
                        </a>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default Unlock;
